<template>
  <div>
    <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls">
      <div class="a-ui-tab__file-flex-block">
        <div class="a-ui-tab__file-item-left">
          <h3>
            {{$t('labels.bid')}}
          </h3>
        </div>
        <div class="a-ui-tab__file-item-right">
          <button class="gui-btn gui-btn--red"
                  @click.prevent.stop="onDownloadAllFilesClick">Скачать файлы одним архивом</button>
        </div>
      </div>
    </div>

    <div class="admin__a-tab-content admin__a-tab-content--show">
      <div class="a-container-form">
        <div class="a-label a-label--w-280">{{$t('form.lot.requests-table.bid-status')}}:</div>
        <span class="a-input a-input--disabled" :class="{'u-red-color u-font-size-22 u-hr-underline': bid.state.SUSPENDED}" v-t="bid.state.label"></span>
        <span type="button" class="gui-btn-none-style"
              @click="onBidSignCheckClick"
              v-if="bid.hasSign">
              <img class="accreditation__reg-img" src="@/assets/img/static/b-icon_edit.svg" alt="">
            </span>
      </div>
      <div class="a-container-form" v-if="bid.state.DECLINED">
        <div class="a-label a-label--w-280">{{$t('form.lot.reason-for-rejection')}}:</div>
        <p class="a-input a-input--disabled ">
          {{bid.reason}}
        </p>
      </div>
      <div class="a-container-form" v-if="bid.permissions.CAN_EDIT_BID">
        <div class="a-label a-label--w-280">{{$t('form.lot.additional-information')}}:</div>
        <textarea class="a-textarea" rows="2" v-model="bid.description" @blur="saveForm()"></textarea>
      </div>
      <div class="a-container-form" v-else-if="bid.description">
        <div class="a-label a-label--w-280">{{$t('form.lot.additional-information')}}:</div>
        <p class="a-input a-input--disabled">{{bid.description}}</p>
      </div>

      <div class="a-container-form a-container-form--align-start" v-if="bid.permissions.CAN_EDIT_BID || bid.files.length > 0">
        <div class="a-label a-label--w-280">{{$t('labels.files')}}:</div>
        <div >
          <file-link :name="file.name"
                     :size="file.size"
                     :link="externalLink(file.uid)"
                     :removable="bid.permissions.CAN_EDIT_BID"
                     :key="file.uid"
                     :signed="file.hasSign"
                     @onsigncheck="onBidFileSignCheckClick(file.num)"
                     @remove="onRemoveBidFile(file.num)"
                     v-for="file in bid.files">
          </file-link>

          <file-picker @prepared="onBidFileSelected"
                       :signing="lot.permissions.SHOULD_BE_SIGNED"
                       v-if="bid.permissions.CAN_EDIT_BID">
          </file-picker>

          <p class="a-input a-input--disabled" v-else-if="bid.files.length === 0">{{$t('labels.no-files')}}</p>
        </div>
      </div>
    </div>

    <template v-if="bid.documents.length">
      <div class="a-tab__title-block admin__a-tab admin__a-tab">
        <h3>Требуемые документы по предложению</h3>
      </div>
      <div class="admin__a-tab-content admin__a-tab-content--show">
        <files-for-document-in-bid :lot="lot" :bid="bid"></files-for-document-in-bid>
      </div>
      <div class="u-indent-m-b-40px"></div>
    </template>

    <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls">
      <h3>{{$t('form.lot.expert-criteria')}}</h3>
    </div>
    <div class="admin__a-tab-content admin__a-tab-content--show">
      <expert-criteria-in-request :lot="lot" :bid="bid"></expert-criteria-in-request>
    </div>

    <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls">
      <h3>{{$t('form.lot.price-criteria')}}</h3>
    </div>

    <div class="a-die a-die--editing u-margin-b-0">
      <div class="a-die__container u-padding-top-24px u-padding-b-24">
        <div class="a-container-form a-width-100-percent u-padding-top-12px u-padding-bottom-0 a-flex-wrap"
             v-for="(item, itemId) in perLotPriceCriteria"
             :key="'per-lot-price-criteria--' + item.criterion">
          <div class="a-label a-label--auto">{{item.criterionName}}:</div>

          <div class="a-form-field a-width-300"
               :class="{ 'a-input-group--error': $v.perLotPriceCriteria.$each[itemId].value.$error}"
               v-if="item.format.NUMBER">
            <div class="a-col-block-content">
              <div class="a-input-text-after-before">
                <template v-if="bid.permissions.CAN_EDIT_BID || bid.isEditingForRetend">
                  <input-cost class="a-input a-input--w-100 u-margin-right-7"
                              v-model="item.value"
                              @blur="saveForm()"
                              v-if="item.format.NUMBER"></input-cost>
                </template>
                <template v-else>
                  <p class="mr-1">{{item.value | price}}</p>
                </template>

                <p>{{item.okei}}</p>
              </div>
              <p class="a-text-small" v-if="item.minValue || item.maxValue">
                <span v-if="item.minValue" style="padding-right: 8px;">{{$t('form.tender.reduction.min-value')}} - {{item.minValue | price}}</span>
                <span v-if="item.maxValue">{{$t('form.tender.reduction.max-value')}} - {{item.maxValue | price}}</span>
              </p>
            </div>
          </div>

          <div class="a-col-block-content" v-else-if="item.format.CHOICE">
            <div class="a-input-text-after-before">
              <template v-if="bid.permissions.CAN_EDIT_BID || bid.isEditingForRetend">
                <dropdown-new class="select-w-140 u-margin-right-7"
                              :placeholder="'form.tender.reduction.item-not-specified'"
                              v-model="item.value"
                              @change="saveForm()">
                  <option :value="value.value" :key="valueId" v-for="(value, valueId) in item.values">{{value.name}}</option>
                </dropdown-new>
              </template>
              <p v-if="item.value !== undefined">{{item.value | price}} {{item.okei}}</p>
            </div>
          </div>
        </div>

        <div class="a-container-form a-width-100-percent u-padding-top-12px u-padding-bottom-0 a-flex-wrap"
             v-for="(item, itemId) in perLotReductionCriteria"
             :key="'per-lot-price-criteria--' + item.criterion">
          <div class="a-label a-label--auto">{{item.criterionName}}:</div>

          <div class="a-form-field a-width-300"
               :class="{ 'a-input-group--error': $v.perLotReductionCriteria.$each[itemId].value.$error}"
               v-if="item.format.NUMBER">
            <div class="a-col-block-content">
              <div class="a-input-text-after-before">
                <template v-if="bid.permissions.CAN_EDIT_BID || bid.isEditingForRetend">
                  <input-cost class="a-input a-input--w-100 u-margin-right-7"
                              v-model="item.value"
                              @blur="saveForm()"
                              v-if="item.format.NUMBER"></input-cost>
                </template>
                <template v-else>
                  <p class="mr-1">{{item.value | price}}</p>
                </template>

                <p>{{item.okei}}</p>
              </div>
              <p class="a-text-small" v-if="item.minValue || item.maxValue">
                <span v-if="item.minValue" style="padding-right: 8px;">{{$t('form.tender.reduction.min-value')}} - {{item.minValue | price}}</span>
                <span v-if="item.maxValue">{{$t('form.tender.reduction.max-value')}} - {{item.maxValue | price}}</span>
              </p>
            </div>
          </div>
        </div>

        <br><br>
        <div class="a-ui-tab__content-block"  >
<!--          <div class="a-container-form">-->
<!--            <div class="a-label a-label&#45;&#45;w-280">{{$t('form.lot.specs.bid-currency')}}: </div>-->
<!--            <p>{{$t(bidCurrency.label)}}</p>-->
<!--          </div>-->

<!--          <div class="a-container-form">-->
<!--            <div class="a-label a-label&#45;&#45;w-280">{{$t('form.lot.specs.contract-currency')}}: </div>-->
<!--            <dropdown-new class="select-w-180"-->
<!--                          v-model="bid.currencyPay"-->
<!--                          :options="payCurrencies"-->
<!--                          :placeholder="'currency.none'"-->
<!--                          @change="saveForm()"-->
<!--                          v-if="bid.permissions.CAN_EDIT_BID && canEditPayCurrency">-->
<!--            </dropdown-new>-->
<!--            <p v-else>{{$t(contractCurrency.label)}}</p>-->
<!--          </div>-->

          <div class="a-container-form">
            <div class="a-label a-label--w-280">{{$t('form.lot.bid-validy-period')}}:</div>
            <div class="a-flex-start a-align-items-center a-spaces-between">
              <div class="a-form-field"
                   :class="{ 'a-input-group--error': $v.bid.duration.$invalid }"
                   v-if="bid.permissions.CAN_EDIT_BID">
                <input class="a-input a-input--w-80"
                       v-model="bid.duration"
                       @blur="saveForm()">
                <span class="a-validation-error"
                      v-if="!$v.bid.duration.valid">
                        Не может быть меньше 90 дней
                </span>
              </div>
              <p class="mr-1" v-else>{{bid.duration}}</p>
              <p>{{$t('form.lot.calendar-days-with-short')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <specification :lot="lot" :bid="bid"></specification>

    <template v-if="lot.state.RETEND || lot.state.WAITING_FOR_RETEND">
      <!--<v-collapse-wrapper :active="true">-->
      <div class="a-tab__title-block admin__a-tab u-border-0">
        <div class="a-container-form " v-if="nextRetendRequestTimeLeft && retendTimeLeft">
          <div class="a-label a-col-label a-label--w-280">{{$t('form.lot.due-date-for-next-bid')}}:</div>
          <div class="a-col-block-content ">
            <timer :value="nextRetendRequestTimeLeft" @finish="checkPublicLot"></timer>
          </div>
        </div>
        <div class="a-container-form u-indent-m-b-45px" v-if="retendTimeLeft && nextRetendRequestTimeLeft">
          <div class="a-label a-col-label a-label--w-280">{{$t('form.lot.time-left-to-retend-finish')}}:</div>
          <div class="a-col-block-content ">
            <timer :value="retendTimeLeft" @finish="checkPublicLot"></timer>
          </div>
        </div>
        <div class="a-container-form " v-if="lot.antisniper">
          <label class="a-label u-width-615px u-red-color">
            Включено автоматическое продление торга. На {{lot.antisniper}} минут продлевается прием предложений в случае активности участников регистрации изменений в предложении
          </label>
        </div>
      </div>
      <!--</v-collapse-wrapper>-->
    </template>

    <template v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_APPROVE_BID">
      <div class="a-container-form" >
        <div class="a-label ">{{$t('form.lot.requests-table.bid-status')}}:</div>
        <dropdown-new ref="bidState"
                      class="a-input-group select-w-180"
                      :options="bidStates"
                      :placeholder="'bid-state.none'"
                      v-model="bid.state">
        </dropdown-new>
        <button type="button"
                class="gui-btn gui-btn--red"
                :disabled="!isBidStateChanged"
                @click="onApproveBidClick({ verdict: bid.state, reason: bid.reason, regulationsReason: bid.regulationsReason })">{{$t('buttons.save')}}</button>
      </div>
      <div class="a-container-form" v-if="bid.confirmedState">
        <div class="a-label a-label--w-280">{{$t('form.lot.confirmed-request-status')}}:</div>
        <label class="a-input a-input--disabled u-red-color">{{$t(bid.confirmedState.label)}}</label>
      </div>

      <template v-if="bid.state == enums.BidState.DECLINED || bid.state == enums.BidState.CONDITIONALLY_APPROVED">
        <div class="a-container-form">
          <div class="a-label a-label--auto">В соответствии с пунктом Регламента ЭТП:</div>
          <regulations-paragraphs-picker class="a-input-group select-w-180"
                                         @input="value => bid.regulationsReason = value.join('\n\n')"/>
        </div>

        <div class="a-container-form">
            <textarea class="a-textarea accreditation__textarea"
                      rows="4"
                      disabled
                      :value="bid.regulationsReason"
                      placeholder="Тексты пунктов">
            </textarea>
        </div>
      </template>

      <template v-if="bid.state == enums.BidState.DECLINED" >
        <div class="a-container-form" >
          <div class="a-label a-label--auto">В дополнение к регламенту:</div>
          <textarea class="a-textarea accreditation__textarea"
                    rows="2"
                    :disabled="!isBidStateChanged"
                    :placeholder="$t('labels.reason')"
                    v-model="bid.reason"></textarea>
        </div>
        <div class="a-container-form" v-if="bid.confirmedReason" >
          <a class="a-textarea a-textarea--disabled accreditation__textarea" v-model="bid.confirmedReason"></a>
        </div>
      </template>
    </template>

    <div class="admin-buy__block-gui-btn" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_EDIT_BID_FOR_RETEND && lot.request.permissions.CAN_EDIT_BID_FOR_RETEND">
      <button class="gui-btn gui-btn--red" v-if="bid.isEditingForRetend" @click.prevent="onSendBidForRetendClick">
        {{$t('buttons.send-bid')}}
      </button>
      <button class="gui-btn gui-btn--red" v-if="bid.isEditingForRetend">
        {{$t('buttons.cancel-bid')}}
      </button>
      <button class="gui-btn gui-btn--red" v-else @click.prevent="onEditBidForRetendClick">
        {{$t('buttons.modify-bid')}}
      </button>
    </div>

    <div class="a-container-form" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_REMOVE_BID && lot.request.permissions.CAN_REMOVE_BID">
      <button class="gui-btn gui-btn--red" type="button" @click="onRemoveBidClick">{{$t('buttons.delete-bid')}}</button>
    </div>
    <div class="a-container-form" v-if="lot.request.permissions.CAN_ADD_BID">
      <button class="gui-btn gui-btn--red" type="button" :disabled="!lot.request.isFilled" @click="onAddBidClick">{{$t('buttons.add-bid')}}</button>
    </div>
    <div class="a-container-form" v-if="lot.request.permissions.CAN_SEE_PUBLIC_LOT_SIGN_REQUEST">
      <router-link class="gui-btn gui-btn--red gui-btn--w-300"
                   tag="button"
                   :disabled="!lot.request.isFilled"
                   to="request#sending-request">
        Перейти для подписания заявки
      </router-link>
    </div>

    <signing-dialog ref="signBid"
                    @signed="signBid">
    </signing-dialog>
  </div>
</template>

<script>
  import { required } from '@/validators'
  import Specification from './Specification'
  import ExpertCriteriaInRequest from './PerLotExpertCriteria'
  import CommonMixins from '../../mixins/common'
  import TimersMixins from '../../mixins/timers'
  import SigningDialog from '@/components/common/dialogs/SigningDialog'
  import BidState from '@/api/types/bid-state'
  import Currency from '@/api/types/currency'
  import TemplateItem from "../../../../admin/catalogs/templates/TemplateItem";
  import FilesForDocumentInBid from "../../request/FilesForDocumentInBid";
  import RegulationsParagraphsPicker from '@/components/common/inputs/RegulationsParagraphsPicker'

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      },

      bid: {
        type: Object,
        required: true
      }
    },

    components: {
      TemplateItem,
      Specification,
      ExpertCriteriaInRequest,
      SigningDialog,
      FilesForDocumentInBid,
      RegulationsParagraphsPicker
    },

    mixins: [
      CommonMixins,
      TimersMixins
    ],

    computed: {
      perLotPriceCriteria() {
        return this.bid.criteria.price.filter(e => e.unit && e.unit.LOT);
      },

      perLotReductionCriteria() {
        return this.bid.criteria.reduction.filter(e => e.unit && e.unit.LOT);
      },

      perLotExpertCriteria() {
        return this.bid.criteria.price.filter(e => e.unit && e.unit.LOT);
      },

      editable() {
        return !!this.lot.request.permissions.HAS_ACCREDITATION;
      },

      bidStates() {
        return [
          {
            id: BidState.ACTIVE,
            name: this.$t('bid-state.active'),
            disabled: !this.bid.permissions.CAN_ACTIVATE_BID
          },
          {
            id: BidState.DECLINED,
            name: this.$t('bid-state.declined'),
            disabled: !this.bid.permissions.CAN_DECLINE_BID
          }
        ]
      },

      isBidStateChanged() {
        return this.bid.state.valueOf() != this.bid.stateOriginal.valueOf();
      },

      payCurrencies() {
        const result = [
          { id: Currency.EMPTY, name: 'currency.none', disabled: true },
          { id: Currency.BYN, name: 'currency.byn' }
        ];

        if (!this.lot.currency.BYN) {
          result.push({ id: this.lot.currency.valueOf(), name: this.lot.currency.label })
        }

        return result;
      },

      canEditPayCurrency() {
        return !this.currentOrganization.isResident && this.payCurrencies.length > 2;
      },

      bidCurrency() {
        return (this.bid.currencyBid && !this.bid.currencyBid.EMPTY ? this.bid.currencyBid : this.lot.currency)
      },

      contractCurrency() {
        return (this.bid.currencyPay && !this.bid.currencyPay.EMPTY ? this.bid.currencyPay : new Currency(Currency.BYN))
      }
    },

    validations: {
      bid: {
        duration: {
          required,
          valid(value) {
            return value >= 90;
          }
        }
      },
      perLotPriceCriteria: {
        $each: {
          value: {
            valid: (item, vm) => {
              const min = +vm.minValue;
              const max = +vm.maxValue;
              if (!min && !max) return true;

              return (min && vm.value >= min || !min) && (max && vm.value <= max || !max);
            }
          }
        }
      },
      perLotReductionCriteria: {
        $each: {
          value: {
            valid: (item, vm) => {
              const min = +vm.minValue;
              const max = +vm.maxValue;
              if (!min && !max) return true;
              return (min && vm.value >= min || !min) && (max && vm.value <= max || !max);
            }
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
